import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import FileHistory from './file-history';
import FileHistoryDetail from './file-history-detail';
import FileHistoryUpdate from './file-history-update';
import FileHistoryDeleteDialog from './file-history-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={FileHistoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={FileHistoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={FileHistoryDetail} />
      <ErrorBoundaryRoute path={match.url} component={FileHistory} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={FileHistoryDeleteDialog} />
  </>
);

export default Routes;
